import { useTranslation } from 'react-i18next';
import { Segment, Icon } from 'semantic-ui-react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEmpty, map } from '../../utils/lodash';
import { EmptyContainer } from '../../components';

const TodoSegment = ({ todoList = [], loading = false }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const visitActivity = useCallback(
    (id, tab = 'evaluation') => {
      navigate(`/activities/${id}/${tab}`);
    },
    [navigate]
  );

  return (
    <>
      <Segment className="content-segment-dashboard-todo" loading={loading}>
        {isEmpty(todoList.docs) ? (
          <EmptyContainer msg={t('dashboard.todo.empty')} />
        ) : (
          <Segment.Group className="todo-segments">
            {map(todoList.docs, (item, i) => {
              return item ? (
                <Segment
                  key={i}
                  className="todo-container"
                  onClick={() => visitActivity(item.projectId, item.tab)}
                >
                  <div className="todo-container-sub">
                    <div className="todo-info-wrap">
                      <div className="todo-info-wrap-sub">
                        <div className="todo-info-wrap-sub-container-icon">
                          <Icon
                            name="circle"
                            size="small"
                            color={
                              item.statusId === 1
                                ? 'orange'
                                : item.statusId === 2
                                  ? 'green'
                                  : item.statusId === 3
                                    ? 'blue'
                                    : 'red'
                            }
                          />

                          <label className="todo-info-description">
                            {item.statusId === 1
                              ? t('common.in_development')
                              : item.statusId === 2
                                ? t('common.active')
                                : t('common.completed')}
                          </label>
                        </div>

                        {item.criticality === 'HIGH' ? (
                          <div className="critical-info">
                            {t('dashboard.todo.urgent')}
                          </div>
                        ) : item.criticality === 'UPCOMING' ? (
                          <div className="upcoming-info">
                            {t('dashboard.todo.upcoming')}
                          </div>
                        ) : null}
                      </div>
                      <label className="todo-info">{item.label}</label>
                      <label className="todo-info-date">
                        {item.tab === 'documentation'
                          ? t('dashboard.todo.end_date')
                          : t('dashboard.todo.greenlight_date')}
                        : {item.date}
                      </label>
                    </div>
                  </div>

                  <div className="todo-action-container-custom">
                    <Icon name="angle right" color="black" />
                  </div>
                </Segment>
              ) : null;
            })}
          </Segment.Group>
        )}
      </Segment>
    </>
  );
};

export default TodoSegment;
